import React from 'react'
import styled from 'styled-components'
import { withRouteData, Head } from 'react-static'

import AboutPage from '../components/pages/about/About'

const Wrapper = styled.div`
  position: relative;
`

class About extends React.Component {
  state = { mobile: true }
  detectWindowWidth = this.detectWindowWidth.bind(this)
  onResize = this.onResize.bind(this)

  componentDidMount() {
    this.detectWindowWidth()
    this.onResize()
  }

  detectWindowWidth() {
    if (typeof window === 'undefined') return
    this.setState({ mobile: window.innerWidth < 801 })
  }

  onResize() {
    if (typeof window === 'undefined') return
    window.addEventListener('resize', this.detectWindowWidth)
  }

  render() {
    // const { latest} = this.props
    const { mobile } = this.state
    return (
      <Wrapper>
        <Head>
          <meta
            name="description"
            content="About the studio - Bagnall Hill Recording Studio is an independent recording studio located in Te Pahu, a small rural settlement south west of Hamilton. Once a storage shed for a trucking company, the building has been rebuilt as a spacious, natural-sounding studio and houses an impressive collection of recording equipment and instruments."
          />
          <title>About</title>
        </Head>
        {/* <AboutPage latestSlug={latest[0].slug} mobile={mobile} /> */}
        <AboutPage mobile={mobile} />
      </Wrapper>
    )
  }
}

export default withRouteData(About)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/About.js